import { render, staticRenderFns } from "./HomeFeatures.vue?vue&type=template&id=5f7c33c5&scoped=true"
import script from "./HomeFeatures.vue?vue&type=script&lang=js"
export * from "./HomeFeatures.vue?vue&type=script&lang=js"
import style0 from "./HomeFeatures.vue?vue&type=style&index=0&id=5f7c33c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c33c5",
  null
  
)

export default component.exports